//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { endPanduan } from '@/api/lalisai'
import { getView } from '@/api/jfhl'
export default {
  name: 'card',
  props: {
    title: {
      // type: String,
      default: ''
    },
    top: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      partyId: '1'
    }
  },
  created () { },
  mounted () { },
  methods: {
    Team () {
      this.$router.push({ name: 'lalisaiTeam' })
    }
  }
}
